import { Button, IconButton, InputAdornment, Tooltip, Typography } from "@mui/material";
import { Bookmarks, Clear } from "@mui/icons-material";
import { useTranslation } from "react-i18next";

export function ColleagueSelectFieldEndIcons({
  handleStoreColleagues,
  isLoading,
  isPreStored,
  disabled,
  onClear
}: Readonly<{
  handleStoreColleagues: () => void;
  isLoading: boolean;
  isPreStored: boolean;
  disabled: boolean;
  onClear: () => void;
}>) {
  const { t } = useTranslation();

  return (
    <InputAdornment
      position="end"
      data-testid="choose-colleagues-textField-input-adornment"
      sx={{ height: "auto" }}
    >
      <IconButton data-testid="select-colleagues-field-btn-onClear" onClick={onClear}>
        <Clear />
      </IconButton>
      <Button
        data-testid="select-colleagues-field-btn-handleStoreColleagues"
        onClick={handleStoreColleagues}
        loading={isLoading}
        disabled={disabled}
        variant={"text"}
        sx={{ minWidth: "40px", height: "40px" }}
      >
        <Tooltip
          title={<Typography>{t("Store the colleagues you want to see every time")}</Typography>}
        >
          <Bookmarks color={isPreStored ? "primary" : "action"} />
        </Tooltip>
      </Button>
    </InputAdornment>
  );
}
